import LocalizationService from '../../../Services/Services.Secondary/Localization/LocalizationService';

const resx = LocalizationService.getInstance();

const workspaceText = resx.getLocalizedResource('Workspace_Text');
const serviceText = resx.getLocalizedResource('ServiceName_text');
const statusText = resx.getLocalizedResource('ServiceAvailability_text');
const serviceAnnouncementText = resx.getLocalizedResource('ServiceAnnouncement_text');
const detailsText = resx.getLocalizedResource('Details_text');
const dateText = resx.getLocalizedResource('IncidentCreatedDate_text');

export const columnsServiceStatus = [
  {
    field: 'workspace',
    content: workspaceText,
    sortable: true,
    display: {
      width: '20.83%',
    },
  },
  {
    field: 'name',
    content: serviceText,
    sortable: true,
    display: {
      width: '20.83%',
    },
  },
  {
    field: 'status',
    content: statusText,
    sortable: true,
    display: {
      width: '12.5%',
    },
  },
  {
    field: 'statusDescription',
    content: serviceAnnouncementText,
    sortable: true,
    display: {
      width: '41.66%',
    },
  },
];

export const columnsHealthHistory = [
  {
    field: 'date',
    content: dateText,
    sortable: true,
    display: {
      width: '16.66%',
    },
  },
  {
    field: 'workspace',
    content: workspaceText,
    sortable: true,
    display: {
      width: '16.66%',
    },
  },
  {
    field: 'service',
    content: serviceText,
    sortable: true,
    display: {
      width: '16.66%',
    },
  },
  {
    field: 'description',
    content: detailsText,
    sortable: true,
    display: {
      width: '45.83%',
    },
  },
];
